import { render, staticRenderFns } from "./BlueCallToAction.vue?vue&type=template&id=f2946a58&scoped=true&"
import script from "./BlueCallToAction.vue?vue&type=script&lang=js&"
export * from "./BlueCallToAction.vue?vue&type=script&lang=js&"
import style0 from "./BlueCallToAction.vue?vue&type=style&index=0&id=f2946a58&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2946a58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
